import React, { useState } from "react";
import { Link } from "react-router-dom";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";
import State from "../State";
import ReactJson from "react-json-view";
import {
  createLot,
  trackLotEvent,
  fetchLotEvents,
  fetchLot,
} from "../../../network/fetch";

const Step1Form = () => {
  const [metadata, setMetadata] = useState(null);
  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
          <p className="tutorial-title">Consultez les données</p>
          <p>
            En tant que consommateur, vous souhaitez en savoir plus sur la
            provenance du produit. Dans un cas réel, vous pourriez scanner le QR
            code sur l'emballage pour accéder à toutes les informations de la
            chaîne de production. Ici, cliquez simplement sur le bouton
            ci-dessous pour consulter les données brutes.
          </p>
        </>
      ),
      position: {
        top: "210px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "450px",
      },
      closeLabel: "hidden",
      nextLabel: "Continuer",
    },
    // Ajoutez plus d'étapes si nécessaire
  ]);

  const total_steps = 4; // Par exemple, s'il y a 5 étapes au total
  const current_step = 4; // Étape actuelle
  const [tutorialStep, setTutorialStep] = useState(0);

  const handleNextTutorialStep = () => {
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées
    }
  };

  const handleCloseTutorial = () => {
    setTutorialStep(-1);
  };

  const onSetMetadata = async (e) => {
    e.preventDefault();
    setMetadata(State.lots[0]);
    State.lots[0]?.lotId &&  fetchData(State.lots[0]?.lotId);
  };

  const fetchData = async (lotId, data = {}) => {
    console.log("=== lotId === Step4Form.js === key: 203187 ===");
    console.dir(lotId, { depth: null, colors: true });
    console.dir(data, { depth: null, colors: true });
    console.log("=================================");
    const resp = await fetchLot(lotId);
    const resp2 = await fetchLotEvents(lotId);

    let resultData = { ...data };
    if (resp.success === true) {
      if (resp.data.lot.quantity) {
        if (
          Math.round(resp.data.lot.quantity / 1000000) ==
          resp.data.lot.quantity / 1000000
        ) {
          resp.data.lot.readableQuantity =
            resp.data.lot.quantity / 1000000 + "";
        }
      }
      if (resp.data.lot.timestamp) {
        resp.data.lot.readableTimestamp = new Date(
          resp.data.lot.timestamp * 1000
        )
          .toISOString()
          .split("T")[0]
          .split("-")
          .reverse()
          .join("/");
      }
      resultData = { ...resultData, [lotId]: { ...resp.data } };
    }
    if (resp.success === true && resp2.success === true) {
      if (resp2.data.lotEvents?.length) {
        for (let i = 0; i < resp2.data.lotEvents.length; i++) {
          if (resp2.data.lotEvents[i].quantity) {
            if (
              Math.round(resp2.data.lotEvents[i].quantity / 1000000) ==
              resp2.data.lotEvents[i].quantity / 1000000
            ) {
              resp2.data.lotEvents[i].readableQuantity =
                resp2.data.lotEvents[i].quantity / 1000000 + "";
            }
          }

          if (resp2.data.lotEvents[i].timestamp) {
            resp2.data.lotEvents[i].readableTimestamp = new Date(
              resp2.data.lotEvents[i].timestamp * 1000
            )
              .toISOString()
              .split("T")[0]
              .split("-")
              .reverse()
              .join("/");
          }
        }
      }
      resultData[lotId].lotEvents = resp2.data.lotEvents;
    }
    setMetadata(resultData);

    if (resp.success === true && resp.data.lot.subLotIds) {
      const lots = resp.data.lot.subLotIds.split(",");
      for (let i = 0; i < lots.length; i++) {
        let returnedData = await fetchData(lots[i], { ...resultData });
        resultData = { ...returnedData };
      }
    }
    return resultData;
  };

  return (
    <form className="container form-4">
      <div className="form-heading-wrapper">
        <ProgressBar total_steps={total_steps} current_step={current_step} />
      </div>

      {tutorialStep >= 0 && (
        <TutorialPopup
          content={tutorialSteps[tutorialStep].content}
          position={tutorialSteps[tutorialStep].position}
          isVisible={tutorialStep >= 0}
          onNext={handleNextTutorialStep}
          onClose={handleCloseTutorial}
          txUrl={null}
          showArrow={tutorialSteps[tutorialStep].showArrow === true}
          tmpNextLabel={tutorialSteps[tutorialStep].nextLabel}
          tmpCloseLabel={tutorialSteps[tutorialStep].closeLabel}
        />
      )}

      <div className="fiels-main-wrapper">
        {/*<div className='action-btn'>
                    <Link to="/" className="btn btn-primary">
                        Voir les données sur la blockchain
                    </Link>
                </div>*/}

        <div className="qr-wrapper">
          <img src="./volaille_qr.png" alt="QR Code" />
        </div>
        <div className="show-blockchain-data">
          <button className="btn btn-primary" onClick={onSetMetadata}>
            Voir les données du produit
          </button>
        </div>
        {metadata && (
          <div className="metadata-display">
            <h4>Données du produit :</h4>
            <ReactJson
              src={metadata}
              displayRoot={false} // Pour masquer l'objet racine (facultatif)
              theme="monokai" // Vous pouvez changer ce thème selon vos préférences
              collapsed={false} // Pour s'assurer que le JSON est entièrement déployé
              displayDataTypes={false} // Pour masquer les types de données (facultatif)
              displayObjectSize={false} // Pour masquer la taille de l'objet (facultatif)
              enableClipboard={false} // Pour désactiver le bouton de copie (facultatif)
            />
          </div>
        )}
      </div>
    </form>
  );
};

export default Step1Form;
